package music.jammers.client.shared.event.track.data.repository

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import music.jammers.client.shared.event.track.domain.repository.EventTrackRepository
import music.jammers.shared.event.domain.model.EventMember
import music.jammers.shared.event.track.domain.model.AddEventTrack
import music.jammers.shared.event.track.domain.model.EventTrack
import music.jammers.shared.event.track.domain.model.UpdateEventTrack

internal class EventTrackRepositoryImpl(
    private val httpClient: HttpClient,
) : EventTrackRepository {

    override suspend fun create(
        eventId: Long,
        addEventTrack: AddEventTrack,
    ): EventTrack = httpClient.post("events/$eventId/tracks") {
        contentType(ContentType.Application.Json)
        setBody(addEventTrack)
    }.body()

    override suspend fun delete(eventTrackId: Long) {
        httpClient.delete("events/tracks/$eventTrackId") {
            contentType(ContentType.Application.Json)
        }
    }

    override suspend fun update(
        eventTrackId: Long,
        updateEventTrack: UpdateEventTrack,
    ): EventTrack = httpClient.put("events/tracks/$eventTrackId") {
        contentType(ContentType.Application.Json)
        setBody(updateEventTrack)
    }.body()

    override suspend fun get(eventTrackId: Long): EventTrack = httpClient.get("events/tracks/$eventTrackId").body()

    override suspend fun acceptMember(eventMemberId: Long): EventMember =
        httpClient.put("events/members/$eventMemberId/signIn").body()

    override suspend fun cancelMember(eventMemberId: Long) {
        httpClient.put("events/members/$eventMemberId/signOut")
    }
}